module.exports = __webpack_public_path__ + "img/request.2892001c.svg";